<template>
  <article id="CITA">
    <VHeader :footnotes="footnotes" />
    <transition name="fade" mode="out-in" appear>
      <router-view :footnotes="footnotes"></router-view>
    </transition>

    <div class="offset-top-6">
      <VFootnotes :footnotes="footnotes" />
    </div>
  </article>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ERROR_FATAL_CODE, CITA_IDENTIFY, CITA_REQUEST, CITA_AUTH, CITA_CONFIRM } from '@/router/route-types';
import Footnotes from '@/utils/Footnotes';
import { convertChargingCycleAfter } from '@/utils/price';

export default {
  name: 'CitaContainer',

  components: {
    VHeader: () => import('@/components/Cita/Header'),
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  data() {
    return {
      footnotes: new Footnotes(),
    };
  },

  computed: {
    ...mapState('cita', ['chargingCycle']),

    ...mapGetters('cita', [
      'isPageTypeAnonymous',
      'isPageTypeAnonymousAuthenticated',
      'isPageTypeAnonymousWithMsisdn',
      'isPageTypeNonAnonymousSimple',
      'isPageTypeNonAnonymousCaptcha',
      'isPageTypeNonAnonymousCapOtp',
      'isPageTypeNonAnonymousXtcOtp',
    ]),
  },

  created() {
    this.$router
      .replace({
        name: (() => {
          switch (true) {
            case this.isPageTypeAnonymousAuthenticated:
              return CITA_CONFIRM;
            case this.isPageTypeAnonymousWithMsisdn:
              return CITA_AUTH;
            case this.isPageTypeAnonymous:
              return CITA_IDENTIFY;
            case this.isPageTypeNonAnonymousSimple:
            case this.isPageTypeNonAnonymousXtcOtp:
            case this.isPageTypeNonAnonymousCaptcha:
              return CITA_CONFIRM;
            case this.isPageTypeNonAnonymousCapOtp:
              return CITA_REQUEST;
            default:
              return ERROR_FATAL_CODE;
          }
        })(),
      })
      .catch(() => {});

    this.footnotes.add({
      prefix: 'subscriptionFootnote',
      text: this.$t('cita.subscription_footnote', { charging_cycle: convertChargingCycleAfter(this.chargingCycle) }),
    });
  },
};
</script>
